import React from 'react';
import PropTypes from 'prop-types';
import MapSenate from '../Map/Senate';
import { Map } from './styles';
import { Button, Title } from '../InterestingDistricts/styles';
import styled, { css } from 'react-emotion';

const SummaryMap = styled(Map)`
	float: none;
	max-width: 315px;
	width: 300px;
	margin-left: auto;
	margin-right: auto;
	
	svg {
		@media (max-width: 480px) {
			display: block;
			width: 70%;
			margin-left: auto;
			margin-right: auto;
		}
		@media (max-width: 515px) {
			max-height: 132px;
			width: 250px;
		}
	}
	
	@media (min-width: 760px) {
		display: none;
	}

	@media (max-width: 480px) {
		margin-left: auto;
		margin-right: auto;
		width: 100%;
		float: none;
	}
`

export default class WidgetMapOnMobileDevice extends React.PureComponent {
	onClick = (id) => {
		window.top.location.href = `${this.props.link}#/obvod/${id}`;
	}

	render() {
		return <>
			<SummaryMap>
				<MapSenate
					districts={this.props.districts}
					leaders={this.props.leaders}
					mapProps={{ viewBox: '0 0 420 237', height: '177', overflow: 'hidden' }}
					onClick={this.onClick}
					roundIndex={1}
				/>
			</SummaryMap>
		</>;
	}
}

WidgetMapOnMobileDevice.propTypes = {
	link: PropTypes.string.isRequired,
	districts: PropTypes.arrayOf(PropTypes.number).isRequired,
	leaders: PropTypes.object.isRequired
}
